'use strict';

const EMAIL_REGEX = /^(?=((?:(?:[A-Za-z0-9!#$%&'*+=?^_`{|}~-][.]?(?=([A-Za-z0-9!#$%&'*+=?^_`{|}~-]))*)*[^\s.]|"[A-Za-z0-9!@#$%&'*+=?^_`{|}~.\-\s]*")@{1}))\1(?:(?:([A-Za-z0-9][-]?(?=[A-Za-z0-9]*))*[A-Za-z0-9]+\.)+[A-Za-z]{2,})$/;
/**
 * Return if the email is valid
 * @param {string} email
 * @returns {boolean}
 * @example
 *
 * ```ts
 * validate('vladislav.pilipenko@sravni.ru')
 * ```
 */
const validate = (email) => typeof email !== 'undefined' && EMAIL_REGEX.test(email);

exports.EMAIL_REGEX = EMAIL_REGEX;
exports.validate = validate;
//# sourceMappingURL=email.js.map
